export {};

NLMK.fileInput = fileInput;

$(fileInput);

function fileInput() {
    require.ensure(
        ['./module'],
        () => {
            require('./module');
            $.fn.MultiFile.options.STRING = {
                denied: "Вы не можете выбрать файлы с расширением $ext",
                duplicate: "Этот файл уже выбран:↵$file",
                file: "$file",
                remove: "x",
                selected: "Файл выбран. $file",
                toobig: "Файл $file слишком большой (макс. $size)",
                toomany: "Выбрано слишком много файлов (макс. $max)",
                toomuch: "Выбранный файл превышает максимальный размер. ($size)"
            }

            $('.fileInput').on('click', 'label', function () {
                $(this).siblings('.MultiFile-wrap').find('input[type="file"]').last().click();
            });
        },
        'masked-input',
    );
}


// WEBPACK FOOTER //
// ./js/main/module/file-input/index.js